export const REQUIRED_MSG = 'Item obrigatório.'

export const MIN_PROJECTS_CARRIED_OUT =
  'Uma experiência deve ter no mínimo um projeto realizado'
